import { render, staticRenderFns } from "./quote-status-label.vue?vue&type=template&id=f188d82a&"
import script from "./quote-status-label.vue?vue&type=script&lang=ts&"
export * from "./quote-status-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports